export enum CallbackStateEnum {
	None = 'None',
	MicrosoftLogin = 'MicrosoftLogin',
	GoogleLogin = 'GoogleLogin',
	Auth0Login = 'Auth0Login',
	SsoLogin = 'SsoLogin'
}